import { gql } from "@apollo/client";

export const ADD_CATEGORY=gql`
mutation addSubjectCategory($category: String!,$sjId:String!) {
  addSubjectCategory(category: $category, sjId: $sjId)
}
`;

export const GET_OR_CREATE_BULKUPLOAD_CATEGORY = gql`
mutation GetOrCreateBulkUploadCategory($subjectId: UUID!) {
  getOrCreateBulkUploadCategory(subjectId: $subjectId) {
    scId
    scNameCapitalized
  }
}
`

export const GET_CATEGORY=gql`
query getSubjectCategories($sjId: UUID!) {
  allSubjectCategories(
    filter: {deletedAt: {isNull: true}, sjId: {equalTo: $sjId}}
    orderBy: SC_NAME_CAPITALIZED_ASC
  ) {
    nodes {
      scNameCapitalized
      scId
    }
  }
}
`;

export const INSERT_SYNDICATED_VIDEOS=gql`
mutation UploadMultipleMylibrarySyndicatedVideos(
  $libraryId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $files: JSON!
) {
  uploadMultipleMylibrarySyndicatedVideos(
    input: {
      pLId: $libraryId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pFiles: $files
    }
  ) {
    json
  }
}
`;

export const GET_ALL_SYNDICATED_VIDEOS=gql`
query getSyndicatedVideos($input: getSyndicatedVideosInput!) {
  getSyndicatedVideos(input: $input) {
    categoryName
    categoryOriginalName
    categoryId
    datas {
      categoryId
      categoryName
      coverImagePath
      fileId
      filename
      filepath
      filesize
      isClassroom
      playbackTime
      feedId
      sharedBy
    }
    totalCount
  }
}
`;


export const UPDATE_PLAY_BACK_TIME_FOR_SYNDICATED_VIDEO = gql`
mutation upsertVideosPlaybacktime($input: UpsertVideosPlaybacktimeInput!) {
  upsertVideosPlaybacktime(input: $input) {
    clientMutationId
  }
}
`
export const GET_ALL_SYNDICATED_VIDEOS_ADMIN = gql `
query GetSyndicatedVideosByCategoryForAdmin(
  $subjectId: UUID!
  $searchInput: String = "%"
  $classroomIds: [String!]
) {
  getSyndicatedVideosByCategoryForAdmin(
    input: {
      subjectId: $subjectId
      searchInput: $searchInput
      classroomIds: $classroomIds
    }
  ) {
    categoryId
    categoryName
    categoryOriginalName
    datas {
      fileId
      filename
      filepath
      categoryId
      categoryName
      coverImagePath
      filesize
      isClassroom
      playbackTime
    }
    totalCount
  }
}
`
export const UPLOAD_SYNDICATED_VIDEOS_ADMIN = gql`
  mutation UploadMylibrarySyndicatedVideosBySchoolAdmin(
  $files: JSON!
  $classroomIds: [UUID!]
  $subjectId: UUID!
) {
  uploadMylibrarySyndicatedVideosBySchoolAdmin(
    input: {
      pFiles: $files
      pClassroomIds: $classroomIds
      pSubjectId: $subjectId
    }
  ) {
    result: json
  }
}
`;


export const EDIT_SYNDICATED_VIDEOS = gql`
mutation EditSyndicatedVideo(
  $fileId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $newCategoryId: UUID
  $newCoverImage: String
  $newFilename: String
  $newFilepath: String
  $newFilesize: BigInt
) {
  editMylibrarySyndicatedVideo(
    input: {
      pFileId: $fileId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pNewCategoryId: $newCategoryId
      pNewCoverImage: $newCoverImage
      pNewFilename: $newFilename
      pNewFilepath: $newFilepath
      pNewFilesize: $newFilesize
    }
  ) {
    json
  }
}
`;